import React, { useState } from 'react';
import Editor from './Editor';
import { baseAPIURL } from '../../config';

const CreateBlog = () => {
    const [FormData, setFormData] = useState({
        _id: 0,
        title: '',
        type: 'blog',
        metaDescription: '',
        description: '',
    });
    function setHtml(v) {
        setFormData({ ...FormData, description: v });
    }
     // Function to convert file to base64
     const handleImageUpload = (e) => {
        const file = e.target.files[0]; // Get the uploaded file
        if (file) {
            const reader = new FileReader();
            
            // Once the file is loaded, set the base64 URL
            reader.onloadend = () => {
                setFormData({ ...FormData, image: reader.result });
                // reader.result holds the base64 URL
            };
            // Read the file as a Data URL (base64)
            reader.readAsDataURL(file);
        }
    };
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.error(FormData)
        // Simple validation
        if (!FormData.title || !FormData.description || !FormData.metaDescription) {
            setMessage('Please fill out all Required fields.');
            return;
        }
        
        if (!FormData.image) {
            setMessage('Please Select the Image.');
            return;
        }

        // Simulate a POST request to your API (replace with actual API call)

        try {
            // Make API request (example using fetch)
            const response = await fetch(`${baseAPIURL}admin/blog/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(FormData),
            });

            if (response.ok) {
                setFormData({
                    _id: 0,
                    title: '',
                    type: 'blog',
                    metaDescription: '',
                    description: '',
                });
            } else {
                setMessage('Error creating blog post');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <h2 className="text-center mb-4">Create New Blog</h2>
                <div className="col-md-8">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="title">Title</label>
                            <input
                                type="text"
                                id="title"
                                className="form-control"
                                placeholder="Enter blog title"
                                value={FormData.title}
                                onChange={(e) => {
                                    setFormData({ ...FormData, title: e.target.value });
                                }}
                                required
                                maxLength={160}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="shortcontent">Short Content</label>
                            <textarea
                                id="shortcontent"
                                className="form-control"
                                placeholder="Enter short content"
                                rows="2"
                                value={FormData.metaDescription}
                                onChange={(e) => {
                                    setFormData({ ...FormData, metaDescription: e.target.value });
                                }}
                                required
                                style={{ resize: 'none' }}
                                maxLength={160}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="content">Content</label>
                            <Editor html={FormData.description} setHtml={setHtml} />
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="author">Author</label>
                            <input
                                type="text"
                                id="author"
                                className="form-control"
                                placeholder="Enter author name"
                                value={FormData.author}
                                onChange={(e) => {
                                    setFormData({ ...FormData, author: e.target.value });
                                }}
                                required
                            />
                        </div>
                        {message && <p className="text-center text-danger">{message}</p>}
                        <button type="submit" className="btn btn-primary w-100">
                            Submit Blog
                        </button>
                    </form>
                </div>
                <div className="col-md-4">
                    <div className="form-group mb-3">
                        <label htmlFor="title">Image</label>
                        <input
                            required
                            type="file"
                            accept="image/*"
                            className="form-control"
                            onChange={handleImageUpload}
                        />
                        {FormData.image && (
                            <div>
                                <img src={FormData.image} alt="Uploaded" style={{ marginTop: '20px', maxWidth: '100%' }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateBlog;
